<template>
  <div class="r6-firmware-progress px" role="status" aria-live="polite">
    <template v-if="error">
      <img class="logo" :src="images.logo_white" alt="Angry Miao" />
      <div class="progress-text error">{{ error }}</div>
      <button class="button" type="button" @click="$emit('close')">
        {{ $t("back") }}
      </button>
    </template>
    <template v-else-if="percent < 100">
      <img class="logo" :src="images.logo_white" alt="Angry Miao" />
      <a-progress
        class="progress"
        :stroke-color="{
          '0%': '#4136f1',
          '100%': '#8743ff',
        }"
        :percent="percent"
        status="active"
      />
      <div class="progress-text">{{ text }}</div>
    </template>
    <template v-else>
      <img
        class="successful-image"
        :src="images.updated_keyboard || images.logo_white"
        alt=""
      />
      <div class="successful-text">{{ text }}</div>
      <button class="button" type="button" @click="$emit('close')">
        {{ $t("back") }}
      </button>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CyberboardR6FirmwareProgress",
  props: {
    percent: { type: Number, default: 0 },
    text: { type: String, default: "" },
    error: { type: String, default: "" },
  },
  computed: {
    ...mapState("assets", { images: "images" }),
  },
};
</script>

<style lang="scss" scoped>
.r6-firmware-progress.px {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 32px 24px;
  background: #171717;
  color: #ffffff;
  text-align: center;

  .logo {
    width: min(220px, 45vw);
    height: auto;
    margin-bottom: 48px;
  }

  .progress {
    width: min(640px, calc(100vw - 48px));
    margin-bottom: 24px;
  }

  .progress-text {
    max-width: min(640px, calc(100vw - 48px));
    font-size: 18px;
    line-height: 1.5;
    overflow-wrap: anywhere;
  }

  .progress-text.error {
    color: #ff9e9e;
  }

  .successful-image {
    max-width: min(400px, calc(100vw - 48px));
    max-height: 45vh;
    margin: 28px 0;
    object-fit: contain;
  }

  .successful-text {
    max-width: calc(100vw - 48px);
    margin-bottom: 28px;
    font-size: 20px;
  }

  .button {
    @include linear-button;
    width: min(360px, calc(100vw - 48px));
    max-width: calc(100vw - 48px);
    height: 60px;
    margin-top: 28px;
    line-height: 60px;
  }
}
</style>

<style lang="scss">
.r6-firmware-progress.px .progress {
  .ant-progress-inner {
    overflow: visible;
    background-color: transparent;
    background-image: linear-gradient(270deg, #8743ff44 0%, #4136f144 100%);
  }

  .ant-progress-text {
    width: 0;
    color: #8743ff;
    font-size: 20px;
  }

  .ant-progress-bg {
    position: relative;

    &::after {
      position: absolute;
      top: 50%;
      right: 0;
      display: block;
      width: 14px;
      height: 14px;
      margin-top: -7px;
      border-radius: 50%;
      background: #8743ff;
      content: "";
    }
  }
}

@media (max-width: 620px) {
  .r6-firmware-progress.px {
    padding: 24px 18px;

    .logo {
      width: min(180px, 48vw);
      margin-bottom: 36px;
    }

    .progress-text {
      font-size: 16px;
    }

    .successful-image {
      margin: 16px 0;
    }

    .successful-text {
      margin-bottom: 18px;
      font-size: 18px;
    }

    .button {
      height: 52px;
      line-height: 52px;
    }
  }
}
</style>
